<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <div class="col-12 mb-4">
      <div class="pb-4">
        <v-btn
          @click="$router.go(-1)"
          outlined
          style="border: none; background: #fff"
          title="Retourner"
        >
          <v-icon>mdi mdi-arrow-left-thin</v-icon> retour
        </v-btn>
      </div>
      <div class="mt-3 mb-0 pb-0">
        <v-alert type="info">
          {{ $t("business_client_entry") }}
        </v-alert>
      </div>
      <v-row>
        <v-col
          v-for="(item, index) in classes"
          :key="index"
          cols="12"
          sm="6"
          md="3"
        >
          <v-card
            style="background-color: white !important; cursor: pointer"
            class="p-2"
          >
            <!-- Top row with image, name, and menu -->
            <v-row align="center" no-gutters>
              <v-col class="px-4 pt-3">
                <h3 class="text-lg">
                  {{ item._name ? item._name : "N/A" }}
                </h3>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="pr-4">
                <v-btn
                  x-small
                  dark
                  color="orange"
                  fab
                  outlined
                  class="mx-2"
                  @click="editItemAction(item, 0)"
                >
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn
                  x-small
                  dark
                  outlined
                  color="pink"
                  fab
                  @click="editItemAction(item, 1)"
                >
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-card-text class="py-0">
              <v-col class="text-left px-0">
                <h6>
                  <v-icon small>mdi-shield-sun-outline</v-icon> Coût :
                  <span style="color: black">
                    {{ item._defaultValue }} XOF</span
                  >
                </h6>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div @click="dialogCustomer = true" class="add_btn">
            <div class="text-center" style="font-size: 15pt">
              Configurer des frais
            </div>
          </div>
        </v-col>
      </v-row>

      <!--   <v-card elevation="0" class="mt-4">
        <div class="col-12 text-right" style="background: #f8f8f8">
          <v-pagination
            elevation="0"
            v-model="page"
            :length="total_pages"
            :total-visible="7"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="getMarchandCustomers"
          ></v-pagination>
          
        </div>
      </v-card> -->
    </div>

    <v-dialog v-model="dialogCustomer" max-width="400px">
      <v-card>
        <v-card-text class="pt-0 mt-0 mb-0 pb-0">
          <v-form ref="clientForm" v-model="clientFormIsValid">
            <v-container v-show="classestep === 1" class="pt-0 mt-0 mb-0 pb-0">
              <v-row>
                <v-col lg="12">
                  <h3 class="pb-0 pt-5">Ajouter un nouveau frais</h3>
                  <!-- <h4 style="font-weight:bold">
                                       Informations l'école
                                      </h4> -->
                </v-col>
                <v-col cols="12" sm="12" class="pt-0 mt-0 mb-0 pb-0">
                  <label for=""
                    >Choisissez les frais à rajouter à cette classe</label
                  >

                  <v-autocomplete
                    solo
                    :rules="requiredRules"
                    v-model="feeToSave._fee"
                    item-value="_id"
                    :items="fees"
                    label="Sélectionnez un frais"
                    item-text="_name"
                    dense
                    persistent-hint
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="12" sm="12">
                  <label for="">Montant à payer pour ce frais</label>
                  <v-text-field
                    solo
                    v-model="feeToSave._value"
                    type="number"
                    label="Montant"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0 pb-5 mt-0 px-5">
          <div class="text-right px-5">
            <v-btn
              class="pt-0 mt-0 mb-0 pb-0 mr-2"
              color="dark"
              @click="(dialogCustomer = false), (editingCustomer = false)"
            >
              Annuler
            </v-btn>

            <v-btn
              class="pt-0 mt-0 mb-0 pb-0"
              v-if="!editingCustomer"
              :loading="loadings.fee_saving"
              color="primary"
              :disabled="feeToSave._name === null || feeToSave._value === null"
              @click="saveFee()"
            >
              Enregistrer
            </v-btn>
            <v-btn
              v-if="editingCustomer"
              :loading="loadings.fee_saving"
              :disabled="feeToSave._name === null || feeToSave._value === null"
              color="primary"
              @click="updateFee()"
            >
              Mettre à jour
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- *********************************** -->
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import { client } from "../../store/services/client";
import { client as webservice_client } from "../../store/services/webservices-client";
import { fontAwesomePicker } from "font-awesome-picker";
import Swal from "sweetalert2";

export default {
  components: {
    GoToParams,
    "font-awesome-picker": fontAwesomePicker,
  },
  label: "Customers",
  data() {
    return {
           classestep: 1,
      editingCustomer: false,
      categoryClienFormIsValid: false,
      requiredRules: [(v) => !!v || "Ce champ est recquis"],
      loadings: {
        classes: false,
        fee_saving: false,
      },
      classes: undefined,
      schoolClass: undefined,
      fees: [],
      school: undefined,
      all_classes: undefined,
      dialogDelete: false,
      dialogCategory: false,
      dialogCustomer: false,
      id: undefined,
      feeToSave: {
        _class: "",
        _fee: "",
        _value: "",
      },
      headers: [
        { text: "Nom", value: "_name" },
        { text: "Valeur par défaut", value: "_defaultValue" },
        { text: "", value: "actions" },
      ],
      editedIndex: -1,
      editedItem: {},
      actions_items: [
        // {title: "Créer transaction", avatar: 'mdi-currency-usd'},
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],

      categories_actions_items: [
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.toggleEditSchool(item);
          break;
        case 1:
          this.toggleDeleteFee(item);
          break;
      }
    },
    async initialize() {
      if (this.$store.getters.marchand) {
        this.getAllClassFees();
        this.getAllFees();
        this.getSchoolClass();
      }

      //   this.getMarchandCustomers()
      // else
      //   this.getAllclasses()

      // this.getMarchanProducts()
      // this.getCategories()
      // this.getAllMarchandCustomers();
    },

    async getSchoolClass() {
      console.log("coming here");
      const response = await client({
        method: "get",
        url: `/school-payments/classes/${this.$route.params.class_id}`,
      })
        .then((resp) => resp.data)
        .catch(() => {
          return {
            error: "true",
          };
        });
      if (!response.error) this.schoolClass = response;

      console.log(this.schoolClass);
    },
   
    async getAllClassFees() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/class-fee/class/${this.$route.params.class_id}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.classes = false;
        console.log(response);

        this.classes = response;

        console.log(this.classes);
      }
    },
    async getAllFees() {
      this.loadings.classes = true;
      const response = await client({
        method: "get",
        url: `/school-payments/fees/school/${this.$route.params.school_id}`,
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.classes = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.classes = false;
        console.log(response);

        this.fees = response.filter((fee) => fee._defaultValue == null);

        console.log(this.fees);
      }
    },
    async saveFee() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        this.feeToSave._class = this.$route.params.class_id;
        const response = await client({
          method: "post",
          url: "/school-payments/class-fee/",
          data: this.feeToSave,
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            console.log(resp.data);
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.fee_saving = false;
        this.dialogCustomer = false;
        this.getAllClassFees();
        this.toast(response.type, response.message);
      }
    },
   
    async updateFee() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.fee_saving = true;
        const response = await client({
          method: "PUT",
          url: `/school-payments/fees/${this.id}`,
          data: this.feeToSave,
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.fee_saving = false;
        this.editingCustomer = false;
        this.dialogCustomer = false;
        this.getAllClassFees();
        this.toast(response.type, response.message);
      }
    },
    toggleEditSchool(item) {
      this.dialogCustomer = true;
      this.editingCustomer = true;
      this.feeToSave = item;
      this.id = item._id;
    },
    toggleDeleteFee(item) {
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("delete_warning"),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          try {
            const response = await client({
              method: "delete",
              url: `/school-payments/fees/${item._id}`,
            });
            Swal.hideLoading();
            Swal.fire({
              icon: "success",
              text: "Suppression réussi",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            console.log(response);
            await this.getAllClassFees();
            return response.data;
          } catch (error) {
            Swal.hideLoading();
            Swal.fire({
              icon: "error",
              text: "Erreur lors de la suppression",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            return { error: "true" };
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          console.log("finish with modal");
          this.getAllClassFees();
        }
      });
      console.log("finish with modal 2");
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },
    deleteItemConfirm() {},
    getClass(item) {
      return `fa fa-2xl fa-${item._icon}`;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}
svg:not(:host).svg-inline--fa,
svg:not(:root).svg-inline--fa {
  font-size: 20px;
}
.add_btn {
  cursor: pointer;
  border: 1px dashed gray;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: gray;
}
.add_btn:hover {
  background-color: rgb(237, 234, 234);
  color: black;
  transition-duration: 700ms;
}
</style>
